import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, map, switchMap } from 'rxjs/operators';

import { Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { DomainService } from '../services/domain.service';
import { JobsService } from '../services/jobs.service';
import { TestJobsService } from '../services/test-jobs.service';
import { UserSettingsService } from '../services/user-settings.service';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.scss']
})
export class AdminLoginComponent implements OnDestroy, OnInit {
  sub: Subscription;
  loading = true;
  error = false;

  constructor(
    public jobsService: JobsService,
    private authService: AuthService,
    private domainService: DomainService,
    private route: ActivatedRoute,
    private router: Router,
    private testJobsService: TestJobsService,
    private userSettingsService: UserSettingsService
  ) {
    this.sub = this.route.queryParamMap
      .pipe(
        map(params => {
          const token = params.get('token');
          const path = params.get('path');
          const version = params.get('version');
          const testJobId = params.get('test');
          return { token, path, version, testJobId };
        }),
        switchMap(params =>
          this.domainService.domain$.pipe(
            filter(domain => !!domain),
            map(domain => ({
              aid: domain.aid,
              token: params.token,
              path: params.path,
              version: params.version,
              testJobId: params.testJobId
            }))
          )
        )
      )
      .subscribe(params => this.login(params.token, params.aid, params.path, params.version, params.testJobId));
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  ngOnInit(): void {}

  private login(token: string, aid: string, path: string, version: string, testJobId: string) {
    console.log('Loging in admin');
    this.userSettingsService.loginFromClassic = true;

    if (!testJobId) {
      this.testJobsService.clearTestJob();
    }

    this.authService
      .loginWithCustomToken(token, aid)
      .catch(e => {
        console.error(e);
        this.loading = false;
        this.error = true;
      })
      .then(() => {
        if (version) {
          this.userSettingsService.setUiVersion(+version);
        }

        if (testJobId) {
          console.log('Setting test job', testJobId);
          this.testJobsService.setTestJob(testJobId);
        } else if (path) {
          this.router.navigateByUrl(path);
        }
      });
  }
}
